import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PauseIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 16 22">
      <path
        d="M2.5 5.50004C2.5 4.99378 2.91041 4.58337 3.41667 4.58337C3.92293 4.58337 4.33333 4.99378 4.33333 5.50004V16.5C4.33333 17.0063 3.92293 17.4167 3.41667 17.4167C2.91041 17.4167 2.5 17.0063 2.5 16.5V5.50004ZM11.6667 5.50004C11.6667 4.99378 12.0771 4.58337 12.5833 4.58337C13.0896 4.58337 13.5 4.99378 13.5 5.50004V16.5C13.5 17.0063 13.0896 17.4167 12.5833 17.4167C12.0771 17.4167 11.6667 17.0063 11.6667 16.5V5.50004Z"
        fill={'inherit'}
      />
    </SvgWrapper>
  );
};
